import { useEffect, useState } from "react";
import { Input, Button, Select, Result } from "antd";
import { useMutation } from "@tanstack/react-query";
import { savePhoneNumber } from "../apis/finance";
import { useLocation, useNavigate } from "react-router-dom";
import { useLoanApplication } from "GlobalStates/LoanApplication";
import { loanApplicationStages } from "../Helpers/DocKeyNames";
import { ROUTES } from "Features/Routes/routeConstants";
import { Typography } from "antd";
import { toast } from "react-toastify";
const { Option } = Select;
const { Title } = Typography;

export const countryCodes = [
  { code: "US", name: "United States", dialCode: "+1" },
  { code: "IN", name: "India", dialCode: "+91" },
  { code: "UK", name: "United Kingdom", dialCode: "+44" },
  { code: "CA", name: "Canada", dialCode: "+1" },
  { code: "AU", name: "Australia", dialCode: "+61" },
];

const PhoneNumberForm = () => {
  const { state } = useLocation();
  const [contactDetails, setContactDetails] = useState("");
  const [selectedCountry, setSelectedCountry] = useState(countryCodes[0]);
  const [submitted, setSubmitted] = useState(state?.submitted || false);
  const [loading, setLoading] = useState(false);
  const { loanApplication } = useLoanApplication();
  const navigate = useNavigate();

  useEffect(() => {
    if (
      loanApplication.stage === loanApplicationStages.CONTACT_DETAILS_PROVIDED
    ) {
      setSubmitted(true);
    } else if (loanApplication.stage === loanApplicationStages.PENDING) {
      navigate(ROUTES.FINANCE_FLOW);
    } else if (loanApplication.stage === loanApplicationStages.INITIATED) {
      navigate(ROUTES.LOAN_ELIGIBILITY);
    }
  }, [loanApplication, navigate]);

  const mutation = useMutation(savePhoneNumber, {
    onSuccess: () => {
      setSubmitted(true);
      setLoading(false);
      toast.success("Your request has been saved!", {
        autoClose: 1500,
      });
    },
    onError: () => {
      setLoading(false);
      toast.error("Failed to save phone number. Please try again.", {
        autoClose: 1500,
      });
    },
  });

  const handleSaveContactDetails = () => {
    if (!contactDetails.trim()) {
      toast.error("Please enter a valid phone number");
      return;
    }
    setLoading(true);
    mutation.mutate({ dialCode: selectedCountry.dialCode, contactDetails });
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
      }}
    >
      {submitted ? (
        <Result
          status="success"
          title="Your request has been submitted!"
          subTitle="Our financial advisor will contact you soon"
        />
      ) : (
        <>
          <Title level={3}>
            Lastly, let's get your contact details and we'll get you a loan!
          </Title>
          <div
            style={{ textAlign: "center", padding: "2em", marginTop: "2em" }}
          >
            <Select
              style={{ width: "100%", marginBottom: 10 }}
              value={selectedCountry.code}
              onChange={(value) =>
                setSelectedCountry(countryCodes.find((c) => c.code === value))
              }
            >
              {countryCodes.map((country) => (
                <Option key={country.code} value={country.code}>
                  {country.name} ({country.dialCode})
                </Option>
              ))}
            </Select>
            <Input
              addonBefore={selectedCountry.dialCode}
              placeholder="Enter phone number"
              value={contactDetails}
              onChange={(e) => setContactDetails(e.target.value)}
              style={{ marginBottom: 10 }}
              type="number"
            />
            <Button
              type="primary"
              block
              onClick={handleSaveContactDetails}
              loading={loading}
            >
              Submit
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default PhoneNumberForm;
